import React from 'react';

/**
 * App-owned add-from-camera glyph. The camera body and lens provide the
 * object, and the separate plus makes the action legible without relying on
 * color.
 */
const CameraPlusIcon = ({ className = '' }) => (
  <svg
    data-icon="camera-plus"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M8.3 6.2h3.4c.28 0 .5.22.5.5v1.3h-4.4V6.7c0-.28.22-.5.5-.5Z"
      fill="currentColor"
      opacity="0.38"
    />
    <rect
      data-part="object"
      x="3"
      y="8"
      width="11"
      height="9"
      rx="2.2"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinejoin="round"
    />
    <circle
      data-part="lens"
      cx="8.5"
      cy="12.5"
      r="2.4"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      data-part="plus"
      d="M18.5 5v7M15 8.5h7"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>
);

export default CameraPlusIcon;
